export const authors = [
  {
    id: '1',
    name: 'डॉ. अनुराधा देशपांडे',
    nameEnglish: 'Dr. Anuradha Deshpande',
    bio: 'प्रसिद्ध कवयित्री आणि साहित्यिक समीक्षक. त्यांची कविता मराठी साहित्यात नवीन दिशा दाखवते.',
    bioLong: 'डॉ. अनुराधा देशपांडे हे पुणे विद्यापीठातील मराठी साहित्याचे प्राध्यापक आहेत. त्यांनी २५ वर्षांपासून मराठी कवितेच्या क्षेत्रात योगदान दिले आहे. त्यांच्या काव्यसंग्रहांना अनेक राष्ट्रीय पुरस्कार मिळाले आहेत.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400',
    specialization: 'कविता, साहित्यिक समीक्षा',
    worksCount: 3,
    philosophy: 'कविता ही जीवनाची सुगंधी आहे. प्रत्येक शब्दात भावना जिवंत व्हायला हवी.',
    socialLinks: {
      website: '#',
      twitter: '#'
    }
  },
  {
    id: '2',
    name: 'प्रा. विक्रम पाटील',
    nameEnglish: 'Prof. Vikram Patil',
    bio: 'लघुकथा आणि कथासाहित्याचे जाणकार लेखक. ग्रामीण जीवनातील सत्यता त्यांच्या कथांमध्ये प्रतिबिंबित होते.',
    bioLong: 'प्रा. विक्रम पाटील यांनी महाराष्ट्राच्या ग्रामीण भागातील जीवनावर आधारित अनेक लघुकथा लिहिल्या आहेत. त्यांची कथा साध्या मनुष्याच्या संघर्षाची गाथा सांगतात.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    specialization: 'लघुकथा, ग्रामीण साहित्य',
    worksCount: 2,
    philosophy: 'कथा ही आयुष्याचा आरसा आहे. प्रत्येक कथेत जीवनाचा संदेश असावा.',
    socialLinks: {
      website: '#'
    }
  },
  {
    id: '3',
    name: 'सौ. मीनाक्षी जोशी',
    nameEnglish: 'Smt. Meenakshi Joshi',
    bio: 'निबंधकार आणि स्त्रीवादी लेखिका. सामाजिक विषयांवर त्यांचे लेखन प्रभावी आहे.',
    bioLong: 'सौ. मीनाक्षी जोशी या सामाजिक विषयांवर लिहिणार्‍या प्रसिद्ध निबंधकार आहेत. त्यांनी स्त्री सशक्तीकरण आणि सामाजिक न्यायाच्या विषयावर अनेक विचारप्रवर्तक लेख लिहिले आहेत.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400',
    specialization: 'निबंध, सामाजिक विषय',
    worksCount: 2,
    philosophy: 'लेखनाने समाजात बदल घडवून आणावा. शब्दांची शक्ती अमर्याद आहे.',
    socialLinks: {
      website: '#',
      twitter: '#'
    }
  },
  {
    id: '4',
    name: 'श्री. राजेंद्र कुलकर्णी',
    nameEnglish: 'Shri. Rajendra Kulkarni',
    bio: 'नाटककार आणि रंगभूमी संशोधक. मराठी नाट्यसाहित्यात त्यांचे महत्त्वपूर्ण योगदान आहे.',
    bioLong: 'श्री. राजेंद्र कुलकर्णी यांनी मराठी रंगभूमीसाठी अनेक मौलिक नाटके लिहिली आहेत. त्यांची नाटके महाराष्ट्रभर प्रसिद्ध आहेत आणि अनेक पुरस्कार मिळविली आहेत.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
    specialization: 'नाट्यसाहित्य, रंगभूमी',
    worksCount: 1,
    philosophy: 'नाटक हे जीवनाचे प्रतिबिंब आहे. रंगमंचावर जीवन साकार व्हावे.',
    socialLinks: {
      website: '#'
    }
  },
  {
    id: '5',
    name: 'डॉ. सुहास भागवत',
    nameEnglish: 'Dr. Suhas Bhagwat',
    bio: 'भाषांतरकार आणि साहित्यशास्त्रज्ञ. जागतिक साहित्याचे मराठीत भाषांतर करणारे अग्रणी विद्वान.',
    bioLong: 'डॉ. सुहास भागवत यांनी जागतिक साहित्याचे मराठीत उत्कृष्ट भाषांतर केले आहे. त्यांच्या भाषांतरांनी मराठी वाचकांना जागतिक साहित्याचा आस्वाद घेता आला आहे.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400',
    specialization: 'भाषांतर, साहित्यशास्त्र',
    worksCount: 1,
    philosophy: 'भाषांतर ही कला आहे. एका संस्कृतीचा दुसर्‍या संस्कृतीशी सेतू.',
    socialLinks: {
      website: '#',
      twitter: '#'
    }
  }
];

export const works = [
  {
    id: '1',
    title: 'आकाशातील तारे',
    titleEnglish: 'Stars in the Sky',
    authorId: '1',
    category: 'Poetry',
    categoryMarathi: 'कविता / कथा / ललित लेख',
    publishDate: '2025-12-15',
    excerpt: 'रात्रीच्या आकाशात चमकणारे तारे, जणू आपल्या स्वप्नांचे प्रतिबिंब...',
    content: `आकाशातील तारे चमकत आहेत,
रात्रीच्या काळोखात प्रकाश पसरवत आहेत.
प्रत्येक तारा एक स्वप्न आहे,
प्रत्येक किरण एक आशा आहे.

दूर आकाशात असले तरी,
आपल्या हृदयात जवळ आहेत ते.
जीवनाच्या संघर्षात,
दिशा दाखवत आहेत ते.

अंधारात प्रकाश शोधणार्‍यांसाठी,
मार्ग दाखवणारे तारे.
आशेचा किरण देणारे,
जीवनाला अर्थ देणारे.

रात्र संपली की,
तारे लपतात कुठे.
पण आपल्या हृदयात,
त्यांचा प्रकाश कायम राहतो.`,
    coverImage: 'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=800',
    relatedWorks: []
  }
];